"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.missingParam = exports.missingControllerName = exports.missingConfig = exports["default"] = void 0;

var missingParam = function missingParam(param) {
  return "Missing param: ".concat(param);
};

exports.missingParam = missingParam;

var missingConfig = function missingConfig(param) {
  return "Config not found: ".concat(param);
};

exports.missingConfig = missingConfig;

var missingControllerName = function missingControllerName(param) {
  return "Controller name  ".concat(param, " not found");
};

exports.missingControllerName = missingControllerName;
var _default = {
  missingParam: missingParam,
  missingConfig: missingConfig,
  missingControllerName: missingControllerName
};
exports["default"] = _default;